import { Component } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { MenuItems } from './pages-menu';
import { OrganizationData } from '../@core/data/organization.data';
import { NbAccessChecker } from '@nebular/security';

@Component({
  selector: 'ngx-pages',
  styleUrls: ['pages.component.scss'],
  templateUrl: 'pages.component.html',
})
export class PagesComponent {
  validParameter = "";
  menu = [];
  params: any = {};
  constructor(
    private route: ActivatedRoute, private orgService: OrganizationData, public accessChecker: NbAccessChecker) {

    accessChecker.isGranted('view', 'groups').subscribe(i => {
      const a = i;
    });
  }

  ngOnInit() {
    this.route.params
      .subscribe(params => {
        const menuSvc = new MenuItems()

        let group = params?.gid;
        let organization = params?.oid;

        if (!group && !organization) {
          this.orgService.getSelectedId()
            .subscribe((org: string) => {
              let isGroup = org.substring(0, 2) === "G*";
              if (isGroup) {
                group = org.replace("G*", "");
              }
              else {
                organization = org;
              }
            });
        }

        this.menu = menuSvc.getMenuItems(organization, group);
      });
  }
}
